import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

export const SubAdminApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubAdmin: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getSubAdmin}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    addSubAdmin: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addSubAdmin,
        method: "POST",
        body,
      }),
    }),
    getSubAdminById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getSubAdminById}${id}/`,
        method: "GET",
      }),
    }),
    updateSubAdmin: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubAdmin}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    updateStatus: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteSubAdmin: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubAdmin}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useDeleteSubAdminMutation,
  useAddSubAdminMutation,
  useLazyGetSubAdminQuery,
  useLazyGetSubAdminByIdQuery,
  useUpdateSubAdminMutation,
  useUpdateStatusMutation,
} = SubAdminApi;
